var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "91px",
    height: "91px",
    viewBox: "-0.5 -0.5 91 91",
    content: "<mxfile modified=\"2020-07-04T12:53:24.661Z\" host=\"Electron\" agent=\"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) draw.io/12.5.3 Chrome/78.0.3904.130 Electron/7.1.9 Safari/537.36\" etag=\"IrN-mAGMpwfxvYPeb_Ek\" version=\"12.5.3\" type=\"device\"><diagram id=\"b46GhhbTliVr-MqwqiZ4\" name=\"Page-1\">5VdRb5swEP41eexkcIDw2GVdJm3TKqXb+urBBawajIwTYL9+BpuAYc2aLtKqNQ/R3efjfHz32Zcs8DqrN4IU6WceA1u4KK4X+N3CdT0nVN8t0GgAo6UGEkFjDaEB2NKfoEHHgHsaQ2lBknMmaWGDEc9ziKSFESF4ZYftOIstoCAJWFW0wDYiDGZh32ksU42Go+APQJNU2vgPEj0kgu9zs1nOc9ArGelzmNAyJTGvRhC+WeC14FxqK6vXwFpGbbbeP7J6rFdALp/ywMfg+u7q692mvL+l9bf74Evzyb9ydZYDYXvDgylWNj0xkMfXLb/K694Ov01lxpTnKLOUgj8cCXNQBxEhTXt95c/rNKVDnIy5N1VvgGcgRaMCqqEPniExHfWgxwQwIunB7iMxckiO6Y473HKqKnGREa6DTZ5et8HKTlHyvYjAPDUm+E+J8CSRIiYBOUuk2CXNKKxoA8ozCg7Dk3V5fxfunA6fVWPHK0O/X++NOjxAnVTPkK33BNkypq6OVq5VSiVsCxK1K5W6u2wJk7LQ98mO1hC3Au4PaqvmhJGyNHbEMxoZe0cZW3PGRbcbRt3nlNoPICTUJ/VuVn1vIiOs/dFxcIL5ceix3yl/1I3zyfZfE9n+6t+SHfzPZDsIvSy2V5cffy993AV4Mu38N97z5t0003KW6ZGBd6kp4KDX1z4HhZP+Bc/s3nLSPfdCvVPu8KNWhw//F/DNLw==</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 85 64 L 85 75 Q 85 85 75 85 L 15 85 Q 5 85 5 75 L 5 15 Q 5 5 15 5 L 75 5 Q 85 5 85 14.5 L 85 24",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.5,
    cy: 27.5,
    rx: 8.5,
    ry: 8.5,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.5,
    cy: 62.5,
    rx: 8.5,
    ry: 8.5,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.5,
    cy: 62.5,
    rx: 8.5,
    ry: 8.5,
    fill: "#000000",
    stroke: "#000000",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 28 62.5 L 28 32.5",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 64 63 L 29 28",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.b5e93fc8eebeeb3cfd88f86b79549753.svg";
export { ForwardRef as ReactComponent };